import { CategoryType } from './ContractorInfo';
import Tab from './Tab';

export type TabsPropsType = {
  currentTab: string;
  categories: CategoryType[];
  handleTabSelect: (tabName: string) => void;
};

const TabsRow = ({ currentTab, categories, handleTabSelect }: TabsPropsType) => {
  return (
    <div className="px-8 space-x-8 border-b border-b-gray-light flex justify-around text-sm text-teal-dark my-16">
      <Tab currentTab={currentTab} categoryName="about" handleTabSelect={handleTabSelect} />
      {categories.map(category =>
        category.array.length === 0 ? null : (
          <Tab
            key={category.name}
            currentTab={currentTab}
            categoryName={category.name}
            handleTabSelect={handleTabSelect}
          />
        )
      )}
    </div>
  );
};

export default TabsRow;
